import { MODULE } from "./activeTimeEntries.actionTypes";

export const isFetchingListsStatus = (state) => state.getIn([MODULE, "isFetchingListsStatus"]);

export const getActiveLineItem = (state) => state.getIn([MODULE, "activeLineItem"]);

export const getLists = (state) =>
  state.getIn([MODULE, "lists"]).map((l) => ({
    ...l,
    ...l.teamMember,
  }));

export default {};
